export const colors = {
  yellow: "#F3BD48",
  darkYellow: "#E19B03",
  beige: "#DDD5CA",
}
